import { MStoreExceptionResponseModel } from '@/types';

export const ErrorUtils = {
  async getExceptionResponseModelFromBlob(blobData: any): Promise<MStoreExceptionResponseModel> {
    return new Promise<MStoreExceptionResponseModel>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result: any = reader.result as string;
        const model = JSON.parse(result);
        resolve(model);
      };
      reader.onerror = (e: any) => {
        reject(e);
      };
      reader.readAsText(blobData);
    });
  }
};